import OrganizationListPageReducer from './OrganizationListPageReducer';

export default from './OrganizationListPageContainer';

export const OrganizationListPageReducers = {
  OrganizationListPageReducer,
};
